document.addEventListener('DOMContentLoaded', function () {
    const urlParams = new URLSearchParams(window.location.search);
    const promoCode = urlParams.get('promo');

    if (promoCode) {
      const targetItem = document.querySelector(`.accordion-item[data-promo="${promoCode.toLowerCase()}"]`);
      if (targetItem) {
        // Expand the accordion
        targetItem.classList.add('active');

        // Scroll with 120px offset
        const yOffset = -120;
        const y = targetItem.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({
          top: y,
          behavior: 'smooth'
        });
      }
    }
  });